import { render, staticRenderFns } from "./AsPartPopup.vue?vue&type=template&id=066dc632&"
import script from "./AsPartPopup.vue?vue&type=script&lang=js&"
export * from "./AsPartPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports